import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  open(event) {
    event.preventDefault();

    const learningObjectiveId = event.currentTarget.dataset.learningObjectiveId;
    const questionIds = event.currentTarget.dataset.questionIds;
    const turboFrame = document.getElementById("related-questions-modal-frame");

    if (turboFrame && learningObjectiveId) {
      let url = `/reports/practice_smart_performance_report/related_questions_modal?learning_objective_id=${learningObjectiveId}`;
      if (questionIds) {
        url += `&question_ids=${encodeURIComponent(questionIds)}`;
      }
      turboFrame.src = url;
    }

    this.modalTarget.classList.remove("hidden");
    document.body.classList.add("modal-open");
    this.trapFocus();

    this._focusinHandler = (e) => {
      if (!this.modalTarget.contains(e.target)) {
        const focusable = this.getFocusableElements();
        if (focusable.length) focusable[0].focus();
      }
    };
    document.addEventListener('focusin', this._focusinHandler);

    this._mousedownHandler = (e) => {
      if (!this.modalTarget.contains(e.target)) {
        e.preventDefault();
        const focusable = this.getFocusableElements();
        if (focusable.length) focusable[0].focus();
      }
    };
    document.addEventListener('mousedown', this._mousedownHandler);

    this._keydownHandler = (e) => {
      if (e.key === "Escape") {
        this.close(e);
      }
    };
    document.addEventListener("keydown", this._keydownHandler);
  }

  close(event) {
    event.preventDefault();
    this.modalTarget.classList.add("hidden");
    document.body.classList.remove("modal-open");
    this.releaseFocus();

    document.removeEventListener('focusin', this._focusinHandler);
    document.removeEventListener('mousedown', this._mousedownHandler);
    document.removeEventListener("keydown", this._keydownHandler);
    this._focusinHandler = null;
    this._mousedownHandler = null;
    this._keydownHandler = null;
  }

  getFocusableElements() {
    return Array.from(
      this.modalTarget.querySelectorAll(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(el => el.tabIndex >= 0 && !el.hasAttribute('disabled') && el.offsetParent !== null);
  }

  trapFocus() {
    const focusable = this.getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    this._modalTabHandler = (event) => {
      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };

    this.modalTarget.addEventListener('keydown', this._modalTabHandler);
    first.focus();
  }

  releaseFocus() {
    if (this._modalTabHandler) {
      this.modalTarget.removeEventListener('keydown', this._modalTabHandler);
      this._modalTabHandler = null;
    }
  }
}
